import { useApolloClient, useMutation } from '@apollo/client'

export const useMutationWithRefetch = (mutation, options = {}) => {
    const { refetchFields, ...mutationOptions } = options
    const client = useApolloClient()

    const [mutate, response] = useMutation(mutation, {
        ...mutationOptions,
        onCompleted: async (data) => {
            if (refetchFields) {
                // Evict each field directly
                // Evicting the fields from the cache triggers a refetch
                refetchFields.forEach((fieldName) => {
                    client.cache.evict({ fieldName })
                })

                client.cache.gc()
            }
            options.onCompleted?.(data)
        },
    })

    return [mutate, response]
}
